import {Injectable} from "@angular/core";
import {Headers, Http} from "@angular/http";
import {Observable} from "rxjs/Observable";
import {Insurance} from "./insurance";
import {InsuranceDto} from "./insurance-dto";
import {InsurancePrice} from "./insurance-price";

@Injectable()
export class InsuranceService {
    private baseUrl: string = '../rest/';

    constructor(private http : Http) {}

    getData(companyId:number): any {
    }

    loadAdditionalPrice(companyId, id){
        return this.get(companyId,id);
    }

    get(companyId, id){
        return this.http
            .get(`../rest/company/${companyId}/insurancePrice/${id}`, { headers: this.getHeaders()})
            .map((response) => <InsurancePrice> response.json());
    }

    private getHeaders(){
        let hdrs = new Headers();
        hdrs.append('Content-Type', 'application/json');
        return hdrs;
    }

    saveInsurance(insurance: any, companyOid, isEditing:boolean=false) {
        let endpoint = `../rest/company/${companyOid}/insurancePrice`;
        return this.http.post(endpoint, insurance);
    }

    loadData(companyId): any {
        return Observable.forkJoin([
            this.getCategories(companyId),
            this.getInsurances(companyId)
        ]);
    }

    private getInsurances(companyId){
        return this.http
            .get(`../rest/data/insurances/${companyId}`, { headers: this.getHeaders()})
            .map((response) => <Insurance[]>response.json());
    }

    private getCategories(companyId) {
        return this.http
            .get(`../rest/data/category/${companyId}`, { headers: this.getHeaders()})
            .map((response) => <String[]>response.json());
    }

}



// WEBPACK FOOTER //
// ./public/upgrade/feature/insurance/insurance.service.ts